import appStore from 'store';
import api from './api';
import { PAGINATION } from 'common/config';

const store = {
  namespaced: true,
  state: {
    currencyIntroductionList: [],
    pagination: PAGINATION,
    totalCount: 0
  },
  getters: {},
  mutations: {
    setCurrencyIntroductionList(state, payload) {
      state.currencyIntroductionList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    list({ commit }, data) {
      api
        .exchangeCoinsList(data)
        .then(({ data }) => {
          commit('setPagination', { page: data.page, size: data.size });
          commit('setCurrencyIntroductionList', data);
        });
    },
    create(context, data) {
      return api.createExchange(data);
    },
    update(context, data) {
      return api.updateExchange(data);
    },

  }
};

appStore.registerModule('spotCoinAdminStore', store);
